export default __webpack_public_path__ + "70eb8a688d184a7158f84250a7f671a4.png";